import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "form_mail",
  "use": "form_mail-usage",
  "viewBox": "0 0 15 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 15 20\" id=\"form_mail\"><path d=\"M-.002 20.002V9.096h15.001v10.906H-.002Zm9.925-8.343-3.34 3.47-1.371-1.423-.98 1.018 2.351 2.441 4.32-4.488-.98-1.018Zm.575-6.205c-.008-.642.001-3.116-3-3.116s-2.992 2.464-3 3.116v2.337h-2.25V5.454S2.249.001 7.499.001c5.249 0 5.25 5.453 5.25 5.453v2.337h-2.251V5.454Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol